//----------------CORE-----------------//
import React, { useEffect, useState } from "react";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter,
  useLocation,
} from "react-router-dom";
import Test from "components/test";
import { useDispatch } from "react-redux";
import {
  setRole,
  setBranding,
  setUser,
  setLoader,
  setSettings,
  setAnalyticsModes,
  setFleetKpiConfig,
} from "rtkSlices/metaDataSlice";
import { useGetSpecificRoleQuery } from "services/roles";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { SnackbarProvider } from "notistack";
import { useSelector } from "react-redux";
//----------------MUI-----------------//
import { createTheme, ThemeProvider } from "@mui/material/styles";
//-------------EXTERNAL COMPONENTS--------//
import PrivateRoute from "routes/PrivateRoute";
import PublicRoute from "routes/PublicRoute";
import { stashRedirect, clearRedirect } from "Utilities/postLoginRedirect";
import Error from "routes/Error";
import Analytics from "layouts/analytics";
import Admin from "layouts/admin";
import Login from "components/Auth";
import Manager from "layouts/services";
import ServiceCreator from "layouts/solutionCreator";
import Support from "layouts/support";
import AlarmsDashboard from "layouts/alarmsDashboard";
import FleetReports from "layouts/fleetReports";
import ScheduledReports from "layouts/scheduledReports";
import { useGetBrandingQuery } from "services/branding";
import { useGetAnalyticsModesQuery } from "services/analytics";
import { useGetFleetConfigQuery } from "services/reporting";
import MyCustomChildren from "components/SnackBar";
import { useGetUsersQuery } from "services/user";
import CookieCheck from "components/Cookie Check";
import Keys from "Keys";
import "./style.css";

const enObj = {
  serviceName: "Smart Hajj Management",
  pilgrim: "Pilgrim",
  police: "Police",
  medical: "Medical",
  assistance: "Assistance",
  hamlaSupervisor: "Hamla Supervisor",
  criticalAlarms: "Critical",
  majorAlarms: "Major",
  minorAlarms: "Minor",
  warningAlarms: "Warning",
  gender: "Gender",
  age: "Age",
  nationality: "Nationality",
  filters: "Filters",
  listView: "List",
  mapView: "Map",
  heatMapView: "Heat Map",
  search: "Search",
  Monitoring: "Monitoring",
  Alarms: "Alarms",
  Events: "Events",
  disconnected: "Disconnected",
  noAlarms: "No Alarms Found",
  events: "Events",
  noEvents: "No Events found",
  Dashboard: "Dashboard",
  "Alerts Handling": "Alerts Handling",
  logout: "Logout",
  filterss: "Filter(s)",
  connected: "Connected",
  status: "Status",
  group: "Group",
  measurement: "Measurement",
  sensorData: "Sensor Data",
  operator: "Operator",
  value: "Value",
  equal: "Equal",
  greater: "Greater",
  greaterEqual: "Greater & Equal",
  less: "Less",
  lessEqual: "Less & Equal",
  reset: "Reset",
  apply: "Apply",
  activityMonitor: "Activity Monitor",
  messageText: "Message will be sent to ",
  devices: "devices",
  messaging: "Messaging",
  globalGreeting: "Global Greeting",
  eidDay: "Eid Day",
  hajjSeason: "Hajj Season",
  message: "Message",
  cancel: "Cancel",
  submit: "Submit",
  messaging: "Messaging",
  name: "Name",
  updated: "Updated",
  deviceInfo: "Device Information",
  asset: "Asset",
  id: "ID",
  hamla: "Hamla",
  number: "Mobile",
  heartRate: "Heart Rate",
  oxygen: "Oxygen",
  bloodPressure: "Blood Pressure",
  battery: "Battery",
  charging: "Charging",
  wearingStatus: "Wearing Status",
  speed: "Speed",
  "Taken off": "Taken off",
  Wearing: "Wearing",
  realtime: "Realtime",
};

const arObj = {
  serviceName: "منصة نُسك",
  pilgrim: "الحجاج​",
  police: "رجال الأمن​",
  medical: "الممارسين الصحيين​",
  assistance: "المساعدين الميدانيين​",
  hamlaSupervisor: "مشرفين الحملات​",
  criticalAlarms: "الإنذارات الحرجة",
  majorAlarms: "الإنذارات الرئيسية",
  minorAlarms: "إنذارات طفيفة",
  warningAlarms: "إنذارات التحذير",
  gender: "الجنس",
  age: "العمر",
  nationality: "الجنسية",
  filters: "عوامل التصفية",
  listView: "عرض القائمة",
  mapView: "عرض الخريطة",
  heatMapView: "عرض الخريطة الحرارية",
  search: "البحث",
  Monitoring: "مراقبة",
  Alarms: "البلاغات​",
  Events: "الأحداث",
  disconnected: "غير متصل",
  noAlarms: "لا يوجد بلاغات",
  events: "الأحداث",
  noEvents: "لا توجد أحداث",
  Dashboard: "شاشة",
  "Alerts Handling": "إدارة البلاغات",
  logout: "تسجيل الخروج",
  filterss: "عوامل التصفية​",
  connected: "متصل",
  status: "الحالة",
  group: "نوع الدور​",
  measurement: "القراءات​",
  sensorData: "بيانات الاستشعار",
  operator: "المشغل",
  value: "القيمة",
  equal: "متساوي",
  greater: "أكبر",
  greaterEqual: "أكبر من و يساوي",
  less: "أقل",
  lessEqual: "أقل من و يساوي",
  reset: "إعادة تعيين",
  apply: "تطبيق",
  activityMonitor: "مراقبة النشاط",
  messageText: "سيتم إرسال الرسالة إلى",
  devices: "أجهزة",
  messaging: "إرسال رسالة عامة​",
  globalGreeting: "رسالة ترحيبية",
  eidDay: "رسالة معايدة",
  hajjSeason: "رسالة عامة للحج",
  message: "رسالة",
  cancel: "إلغاء",
  submit: "إرسال",
  messaging: "مراسلة",
  name: "الإسم",
  updated: "آخر تحديث",
  deviceInfo: "معلومات الجهاز",
  asset: "الجهاز",
  id: "الهوية الشخصية",
  hamla: "الحملة",
  number: "رقم الجوال​",
  heartRate: "معدل نبضات القلب",
  oxygen: "مستوى الأكسجين",
  bloodPressure: "ضغط الدم",
  battery: "مستوى البطارية",
  charging: "الشحن",
  wearingStatus: "حالة الارتداء",
  speed: "السرعة",
  "Taken off": "غير مرتداة",
  Wearing: "مرتداة حاليًا",
  realtime: "في الوقت الحالى",
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enObj },
    ar: { translation: arObj },
  },
  lng: window.localStorage.getItem("Language")
    ? window.localStorage.getItem("Language")
    : "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

// Records the current in-app URL on every route change, so that an eject to
// /auth/login can send the user back here once they sign in. One component
// rather than a patch at each eject site: it cannot miss a site, it keeps
// working if a new one is ever added, and because it re-runs on every route
// change the stash is always the CURRENT page rather than the one the tab
// happened to boot on. /auth/* is rejected inside stashRedirect as a no-op, so
// landing on the login page never overwrites the real destination.
function StashLocation() {
  const location = useLocation();
  useEffect(() => {
    stashRedirect(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  const metaDataValue = useSelector((state) => state.metaData);
  const [roleState, setRoleState] = React.useState(true);
  const [brandingState, setBrandingState] = React.useState(true);
  const dispatch = useDispatch();

  function getToken() {
    return window.localStorage.getItem("token") || false;
  }

  const brandingRes = useGetBrandingQuery(
    { user: "true", id: "" },
    {
      skip: metaDataValue.skip && !getToken(),
    }
  );

  const userRes = useGetUsersQuery(
    {
      token: window.localStorage.getItem("token"),
      parameters: `?id=${window.localStorage.getItem("user")}`,
    },
    {
      skip: brandingState || !getToken(),
    }
  );
  const roleRes = useGetSpecificRoleQuery(userRes.data?.payload.Users ? userRes.data?.payload.Users[0].role : userRes.data?.payload[0]?.role, {
    skip: roleState || !getToken(),
  });

  // Tenant's enabled analytics granularity modes (dynamic bucket modes). Token-only
  // endpoint — fetch as soon as a token exists; stored in metaData.analyticsModes.
  const modesRes = useGetAnalyticsModesQuery(
    { token: window.localStorage.getItem("token") },
    { skip: !getToken() }
  );

  // Fleet Reports capability (license-gated). Token-only endpoint; returns
  // {enabled:false} for tenants without the feature. Stored tri-state in
  // metaData.fleetKpi — see useFleetKpiConfig.
  const fleetConfigRes = useGetFleetConfigQuery(
    { token: window.localStorage.getItem("token") },
    // NOTE: refetchOnFocus/refetchOnReconnect were REMOVED (RENSAIR "page reloads on every
    // refocus" regression). This query lives at the app ROOT, so refetching it on every
    // window/tab focus dispatched setFleetKpiConfig -> metaData changed -> the ENTIRE App
    // re-rendered on every refocus. The app has re-render-UNSAFE components — route-level
    // inline `component={}` (fixed in PrivateRoute/PublicRoute) and, worse, components
    // DEFINED INSIDE render bodies (e.g. Analytics/TabPanel inside components/Asset View) —
    // so an App re-render remounted and reset the page on every refocus. The staleness this
    // was meant to fix (a session left open across a UTC-day rollover offering a stale
    // timeframe window) is niche and should be handled scoped to the Fleet Reports page
    // (or via a reload), not by refetching a root query on every focus.
    { skip: !getToken() }
  );

  useEffect(() => {
    let url = window.location.href
    // console.log("INITIALIZED WEB APPP")
    // console.log({url})
    if (url.includes("rensair")) {
      let link = document.querySelector("link[rel='icon']")
      if (!link) {
        link = document.createElement("link")
        link.rel = 'icon'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      link.href = "https://xelerate-video.s3.eu-central-1.amazonaws.com/favicon-rensair.ico"
    }
  }, [])

  useEffect(() => {
    if (userRes.isSuccess && !userRes.isFetching) {
      // console.log({userRes})
      // When user updates himself than the api returns the user in Users else it comes in the payload
      let user = userRes.data.payload.Users ? userRes.data.payload.Users[0] : userRes.data.payload[0];
      if (!user || !user?.role) {
        window.localStorage.removeItem("metaData");
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("user");
        window.location.href = "/auth/login";
        /* setTimeout(() => {
          window.location.reload();
        }, 1000); */
      }
      window.localStorage.setItem("role", user?.role);
      setRoleState(false);
      dispatch(
        setUser({
          firstName: user?.firstName || "",
          lastName: user?.lastName || "",
          userName: user?.userName || "",
          phone: user?.phone || "",
          email: user?.email || "",
          userId: user?._id || "",
          pinnedSolutions: brandingRes.data.payload?.pinnedSolutions || [],
        })
      );
    } else if (
      userRes.isError &&
      (userRes.error?.status === 401 ||
        userRes.error?.data?.errorCode === 401)
    ) {
      // Log out ONLY on a genuine auth failure. This used to fire on ANY error — a 500, a
      // 503, even a transient network blip — so a momentary backend hiccup silently wiped
      // the user's session and bounced them to the login screen. That also defeats the
      // backend's deliberate use of 503 for "auth service temporarily unavailable": the
      // whole point of 503 is that the session survives a database wobble. Anything that is
      // not a 401 is left alone; the query stays in its error state and RTK Query will
      // refetch on the next mount/navigation.
      window.localStorage.removeItem("metaData");
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("user");
      window.location.href = "/auth/login";
    }
  }, [userRes.isFetching]);

  useEffect(() => {
    if (roleRes.isSuccess && !roleRes.isFetching) {
      window.localStorage.setItem("Language", "en");
      dispatch(setRole(roleRes.data.payload));
      dispatch(setLoader(false));
    }
  }, [roleRes.isFetching]);

  useEffect(() => {
    if (modesRes.isSuccess && !modesRes.isFetching) {
      dispatch(setAnalyticsModes(modesRes.data?.payload?.modes || []));
    }
  }, [modesRes.isFetching]);

  useEffect(() => {
    if (fleetConfigRes.isSuccess && !fleetConfigRes.isFetching) {
      dispatch(setFleetKpiConfig(fleetConfigRes.data?.payload || { enabled: false }));
    } else if (fleetConfigRes.isError && !fleetConfigRes.isFetching && !fleetConfigRes.data) {
      // MUST resolve the tri-state on failure. Leaving metaData.fleetKpi at null
      // means "still loading" forever — and initialState is static with no
      // preloadedState, so it can never recover: the nav tile stays hidden AND
      // /fleetReports spins indefinitely. Fail CLOSED (entitlement unconfirmed =
      // treat as off); RTK refetches on the next mount, which restores the tile.
      // GUARD `!fleetConfigRes.data`: fail closed ONLY on the INITIAL load. Now that
      // the query refetches on focus/reconnect, a TRANSIENT refetch error must NOT
      // wipe an already-loaded config (RTK retains the last-good `data` across a
      // failed refetch) — otherwise a momentary blip would hide the live feature.
      dispatch(setFleetKpiConfig({ enabled: false }));
    }
  }, [fleetConfigRes.isFetching, fleetConfigRes.isError]);

  useEffect(() => {
    if (brandingRes.isSuccess && !brandingRes.isFetching) {
      dispatch(setSettings(brandingRes.data.payload));
      dispatch(setBranding(brandingRes.data.payload));
      setBrandingState(false);
    }
  }, [brandingRes.isFetching]);

  const Theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1400,
        lg: 1200,
        xl: 1536,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            borderRadius: "200px",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "10px",
          },
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            // paddingTop: "0px",
            // paddingBottom: "0px",
          },
        },
      },
    },
    palette: {
      primary: {
        main: metaDataValue?.branding?.primaryColor
          ? metaDataValue?.branding?.primaryColor
          : Keys?.primary
            ? Keys.primary
            : "#3399ff",
      },
      secondary: {
        main: metaDataValue?.branding?.secondaryColor
          ? metaDataValue?.branding?.secondaryColor
          : Keys?.secondary
            ? Keys.secondary
            : "#607d8b",
      },
      error: {
        main: "#bf3535",
        light: "#844204",
      },
      major: {
        main: "#844204",
        contrastText: "#fff",
      },
      warning: { main: "#fe9f1b" },
      info: { main: "#3399ff" },
    },
    typography: {
      fontFamily: metaDataValue.branding.fonts
        ? metaDataValue.branding.fonts.uploaded == false
          ? metaDataValue.branding.fonts
          : "customfont"
        : Keys?.font
          ? Keys?.uploaded == "false"
            ? Keys?.fonts
            : "customfont"
          : "Open Sans",
    },
  });

  // Boot-time failure that is NOT an auth failure (an authMS 503, a 500, a network blip
  // while loading the signed-in user or their role). 401s never reach here: the request
  // interceptor hard-logs-out on any 401, and the userRes effect above is a backstop.
  // Without this, the shell sat on the splash loader forever: metaData.loader only clears
  // after userRes -> roleRes BOTH succeed, so either query erroring left the user staring
  // at a spinner with no retry and no way out.
  const isNon401Error = (q) =>
    q.isError &&
    !(q.error?.status === 401 || q.error?.data?.errorCode === 401);
  // A 403 (expired/invalid access token — authMS answers every token failure with 403 so the
  // interceptor can silently refresh) MUST still raise this panel. It is tempting to suppress
  // it as "routine", but the splash loader is only ever cleared by `setLoader(false)` in the
  // roleRes success effect — there is no error path that clears it. Suppressing the panel
  // would therefore strand the user on an infinite spinner with no Retry and no way out,
  // which is strictly worse than an honest message. What we DO fix is the wording: a failed
  // token refresh is not "the service is unavailable".
  const isAuthStatus = (q) =>
    q.isError && (q.error?.status === 403 || q.error?.data?.errorCode === 403);
  const authBootError =
    isAuthStatus(brandingRes) || isAuthStatus(userRes) || isAuthStatus(roleRes);
  // brandingRes is the FIRST link of the chain (userRes is skipped until branding
  // succeeds), so a branding failure at boot must show the panel too — otherwise the
  // most likely boot failure (authMS/Mongo down at page load) still left the spinner.
  const bootError =
    getToken() &&
    (isNon401Error(brandingRes) ||
      isNon401Error(userRes) ||
      isNon401Error(roleRes));

  return (
    <ThemeProvider theme={Theme}>
      <BrowserRouter>
        <StashLocation />
        {getToken() ? (
          metaDataValue.loader ? null : (
            <CookieCheck />
          )
        ) : (
          <CookieCheck />
        )}
        {bootError ? (
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
              fontFamily: "inherit",
              textAlign: "center",
              padding: "24px",
            }}
          >
            <h2 style={{ margin: 0 }}>Something went wrong</h2>
            <p style={{ margin: 0, color: "#666", maxWidth: 420 }}>
              We couldn't load your account - the service may be briefly
              unavailable. Your session is still intact.
            </p>
            <div style={{ display: "flex", gap: "12px" }}>
              {/* Full reload, not refetch(): the boot chain is userRes -> roleState ->
                  roleRes -> loader, and a refetch of one query cannot re-drive the whole
                  chain once it has errored part-way. A reload restarts it cleanly. */}
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: "8px 20px",
                  cursor: "pointer",
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  background: "#1976d2",
                  color: "#fff",
                }}
              >
                Retry
              </button>
              <button
                onClick={() => {
                  window.localStorage.removeItem("metaData");
                  window.localStorage.removeItem("token");
                  window.localStorage.removeItem("user");
                  // An explicit sign-out must not leave a stashed destination
                  // behind to hijack the next sign-in in this tab.
                  clearRedirect();
                  window.location.href = "/auth/login";
                }}
                style={{
                  padding: "8px 20px",
                  cursor: "pointer",
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  background: "transparent",
                }}
              >
                Sign out
              </button>
            </div>
          </div>
        ) : (
        <Switch>
          <PublicRoute path="/auth/login" component={Login} />
          <PublicRoute path="/auth/validate" component={Login} />
          <PrivateRoute
            path="/analytics"
            component={Analytics}
            loader={getToken() ? metaDataValue.loader : false}
          />
          <PublicRoute
            path="/auth/forgotPassword"
            component={Login}
            loader={getToken() ? metaDataValue.loader : false}
          />
          <Route path="/auth/resetPassword/:token" component={Login} />
          {/* Legacy redirect: ROI Calculator was removed with the taxonomy restructure. */}
          <Redirect from="/roiCalculator" to="/solutions" />
          <PrivateRoute
            path="/fleetReports"
            component={FleetReports}
            loader={getToken() ? metaDataValue.loader : false}
          />
          <PrivateRoute
            path="/scheduledReports"
            component={ScheduledReports}
            loader={getToken() ? metaDataValue.loader : false}
          />
          <PrivateRoute
            path="/administration"
            component={Admin}
            loader={getToken() ? metaDataValue.loader : false}
          />
          <PrivateRoute
            path="/solutions"
            component={Manager}
            loader={getToken() ? metaDataValue.loader : false}
          />
          <PrivateRoute
            path="/test"
            component={Test}
            loader={getToken() ? metaDataValue.loader : false}
          />
          <PrivateRoute
            path="/support"
            component={Support}
            loader={getToken() ? metaDataValue.loader : false}
          />
          <PrivateRoute
            path="/alarms-dashboard"
            component={AlarmsDashboard}
            loader={getToken() ? metaDataValue.loader : false}
          />
          {/* Legacy redirects: Branding moved under Administration; Solution
              Enablement was removed with the taxonomy restructure. */}
          <Redirect from="/settings" to="/administration/brandManagement" />
          <Redirect from="/solutionEnablement" to="/solutions" />
          <PrivateRoute
            path="/solutionManagement"
            component={ServiceCreator}
            loader={getToken() ? metaDataValue.loader : false}
          />
          <Redirect from="/" to="auth/login" exact />
          <Route component={Error}></Route>
        </Switch>
        )}
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      maxSnack={5}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      content={(key, message) => (
        <MyCustomChildren id={key} message={message} />
      )}
    >
      <App />
    </SnackbarProvider>
  );
}
